<apx-chart id="chart" [series]="series"
           [chart]="chartOptions.chart"
           [xaxis]="chartOptions.xaxis"
           [yaxis]="chartOptions.yaxis"
           [labels]="labels"
           [markers]="chartOptions.markers"
           [colors]="chartOptions.colors"
           [stroke]="chartOptions.stroke"
           [fill]="chartOptions.fill"
           [plotOptions]="chartOptions.plotOptions"
           [tooltip]="chartOptions.tooltip"
           [responsive]="chartOptions.responsive"
></apx-chart>